import React, { FC } from "react";

import Dashboard from "../components/Dashboard";

const DashboardPage: FC = () => <Dashboard/>;

export default DashboardPage;
